import { createSlice } from '@reduxjs/toolkit'
import { apiCallBegan } from '../api'
import {threatIntelInitialState} from '../initialState/threatintelState'


const slice = createSlice({
    name: 'threatIntel',
    initialState: threatIntelInitialState,
    reducers: {
        loadThreatIntelRequested: (threatIntel) => {
            threatIntel.eventsLoading = true
        },
        loadThreatIntelSuccess: (threatIntel, action) => {
            threatIntel.eventsLoading = false
            threatIntel.events = action.payload.response.data.slice(0, threatIntel.displaySize);
            threatIntel.isLastPage = action.payload.response.data.length <= threatIntel.displaySize ? true : false;
        },
        loadThreatIntelFailure: (threatIntel, action) => {
            threatIntel.eventsLoading = false
            threatIntel.events = []
            threatIntel.isLastPage = true
        },

        loadThreatIntelByIdRequested: (threatIntel, action) => {
            threatIntel.selectedEvent = {};
            threatIntel.selectedEventLoading = true;
        },

        loadThreatIntelByIdSuccess: (threatIntel, action) => {
            threatIntel.selectedEventLoading = false;
            threatIntel.selectedEvent = action.payload.response.data ? action.payload.response.data : null;
        },

        loadThreatIntelByIdFailure: (threatIntel, action) => {
            threatIntel.selectedEventLoading = false;
            threatIntel.selectedEvent = null;
        },

        filtersChanged: (threatIntel, action) => {
            threatIntel.filters = action.payload
        },
        sortingChanged: (threatIntel, action) => {
            threatIntel.sorting = action.payload
        },

        resetFilters: (threatIntel) => {
            threatIntel.filters = threatIntelInitialState.filters
        },
        resetSorting: (threatIntel) => {
            threatIntel.sorting = threatIntelInitialState.sorting
        },

        screenshotRequested: (threatIntel, action) => { 
            threatIntel.screenshotsLoading[action.reducerData.id] = true;
        },
        screenshotSuccess: (threatIntel, action) => {
            threatIntel.screenshotsLoading = { ...threatIntel.screenshotsLoading, [action.payload.response.data.id]: false };
            // Store screenshots by event ID
            if (!threatIntel.screenshots) threatIntel.screenshots = {};
            threatIntel.screenshots[action.payload.response.data.id] = action.payload.response.data ? action.payload.response.data.screenshot : null;
        },
        screenshotFailure: (threatIntel, action) => {
            threatIntel.screenshotsLoading[action.reducerData.id] = false;
            threatIntel.screenshots[action.reducerData.id] = null; // Clear screenshot on failure
        },

        unverifyThreatIntel: (threatIntel, action) => {
            threatIntel.unverifyLoading = true;
        },
        unverifyThreatIntelSuccess: (threatIntel, action) => {
            threatIntel.unverifyLoading = false;
            const id = action.reducerData.id;
            threatIntel.events = threatIntel.events.filter(event => event.id !== id);
            if (threatIntel.selectedEvent && threatIntel.selectedEvent.id === id) {
                threatIntel.selectedEvent = {};
            }
            threatIntel.verifyStatusCode = 200;
        },
        unverifyThreatIntelFailure: (threatIntel, action) => {
            threatIntel.unverifyLoading = false;
            threatIntel.verifyStatusCode = 500;
        },
        setStatusCode: (threatIntel, action) => {
            threatIntel.verifyStatusCode = action.payload.verifyStatusCode;
        },

        setPageNo: (threatIntel, action) => {
            threatIntel.pageNo = action.payload.pageNo;
        }

    } 
})

export const {
    loadThreatIntelRequested,
    loadThreatIntelSuccess,
    loadThreatIntelFailure,
    filtersChanged,
    sortingChanged,
    resetFilters,
    resetSorting,
    screenshotRequested,
    screenshotSuccess,
    screenshotFailure,
    loadThreatIntelByIdRequested,
    loadThreatIntelByIdSuccess,
    loadThreatIntelByIdFailure,
    unverifyThreatIntel,
    unverifyThreatIntelSuccess,
    unverifyThreatIntelFailure,
    setStatusCode,
    setPageNo
} = slice.actions

export default slice.reducer;

export const loadThreatIntel = (filters, sorting, pageNo, pageSize, cid) => (dispatch) => {
    let url = `threat-intel/events?filterBy=${filters}&sortBy=${sorting}&pageNo=${pageNo}&pageSize=${pageSize}&customerId=${cid || ''}`;
    return dispatch(apiCallBegan({
            urlPath: url,
            method: 'GET',
            onStart : loadThreatIntelRequested.type,
            onSuccess: loadThreatIntelSuccess.type,
            onError:  loadThreatIntelFailure.type,
        })
    )
}

export const fetchThreatIntelScreenshot = (id, cid) => (dispatch) => {
    return dispatch(apiCallBegan({
        urlPath: `/threat-intel/events/${id}?customerId=${cid || ''}`,
        method: 'GET',
        onStart: screenshotRequested.type,
        onSuccess: screenshotSuccess.type,
        onError: screenshotFailure.type,
        reducerData: { id }
    }));
};

export const loadThreatIntelById = (id, cid) => (dispatch) => {
    return dispatch(apiCallBegan({
        urlPath: `/threat-intel/events/${id}?customerId=${cid || ''}`,
        method: 'GET',
        onStart: loadThreatIntelByIdRequested.type,
        onSuccess: loadThreatIntelByIdSuccess.type,
        onError: loadThreatIntelByIdFailure.type,
    }));
}

export const unverifyEventsThreatIntel = (Id, customerId = '') => (dispatch) => {
    return dispatch(apiCallBegan({
        urlPath: `/threat-intel/unverify/${Id}/${customerId}`,
        method: 'PUT',
        onStart: unverifyThreatIntel.type,
        onSuccess: unverifyThreatIntelSuccess.type,
        onError: unverifyThreatIntelFailure.type,
        reducerData: { id: Id }
    }));

}

export const changeFilters = (filters) => (dispatch) => {
    dispatch(filtersChanged(filters))
}
export const changeSorting = (sorting) => (dispatch) => {
    dispatch(sortingChanged(sorting))
}

export const resetThreatIntelFilters = () => (dispatch) => {
    dispatch(resetFilters())
}
export const resetThreatIntelSorting = () => (dispatch) => {
    dispatch(resetSorting())
}

export const unSetThreatIntelStatusCode = () => {
  return setStatusCode({
    verifyStatusCode: null
  });
}




